export default __webpack_public_path__ + "static/media/trevor.a67f2805.png";